export enum AdbFeatures {
    StatV2 = 'stat_v2',
    Cmd = 'cmd',
    ShellV2 = "shell_v2"
}
